import React,{useEffect} from 'react'
import axios from 'axios';

import {
  Flex,
  Box,
  FormControl,
  FormLabel,
  Input,
  Stack,
  Link,
  Button,
  Heading,
  Text,
  useColorModeValue,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Spinner,
  Select
} from '@chakra-ui/react';
import { Table } from 'antd';



function Organizations() {

  const [orgs, setOrgs] = React.useState([])
  const [tableColumns, setTableColumns] = React.useState([])
  const [tableData, setTableData] = React.useState([])
  const [loading, setLoading] = React.useState(false);
  const [activeOrg, setActiveOrg] = React.useState([])

  const columns = [
    {
      title: 'Organization Name',
      dataIndex: 'organization_name',
      key: 'organization_name',
      width: 200
    },
    {
      title: 'Certificate of Inclusion Number',
      dataIndex: 'certificate_of_inclusion_number',
      key: 'certificate_of_inclusion_number',
      width: 200
    },
    {
      title: 'Primary Point of Contact Name',
      dataIndex: 'primary_point_of_contact_name',
      key: 'primary_point_of_contact_name',
      width: 200
    },
    {
      title: 'Address',
      dataIndex: 'address',
      key: 'address',
      width: 200
    },
    {
      title: 'Phone Number',
      dataIndex: 'phone_number',
      key: 'phone_number',
      width: 200
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      width: 200
    },
    {
      title: 'Acres Enrolled',
      dataIndex: 'acres_enrolled',
      key: 'acres_enrolled',
      width: 200
    },
    {
      title: 'Adopted Acres Contributed in 2023 (Report)',
      dataIndex: 'adopted_acres_target',
      key: 'adopted_acres_target',
      width: 200
    },
    {
      title: 'If necessary, provide additional explanation or comments related to the enrolled acres and adopted acres values given above',
      dataIndex: 'additional_explanation',
      key: 'additional_explanation',
      width: 200
    },
    {
      title: 'Describe the updates you anticipate making and when you would like to discuss those updates with UIC.',
      dataIndex: 'anticipate_updates',
      key: 'anticipate_updates',
      width: 200
    },
    {
      title: 'Have you made any updates to your Section 7 species list or Avoidance & Minimization Measures (AMMs)?',
      dataIndex: 'updates_to_section_7',
      key: 'updates_to_section_7',
      width: 200
    },
    {
      title: 'What conservation measures did you undertake on your adopted acres in 2023?',
      dataIndex: 'conservation_measures',
      key: 'conservation_measures',
      width: 200
    },
    {
      title: 'Describe the implementation of conservation measures and adopted acres managed. Verify if these are the same as in the initial application, or if any changes occurred. Summarize any unforeseen or changed circumstances that impacted annual contribution.',
      dataIndex: 'conservation_measures_implementation',
      key: 'conservation_measures_implementation',
      width: 200
    },
    {
      title: 'Describe whether your adopted acres contained overlap with another CCAA Partners adopted acres. If so, name which Partners have overlap and estimate the number of acres or percentage of overlap',
      dataIndex: 'partners_overlap',
      key: 'partners_overlap',
      width: 200
    },
    {
      title: 'What supplemental measures did you undertake as part of your CCAA implementation in 2023? (check all that apply)',
      dataIndex: 'supplemental_measures',
      key: 'supplemental_measures',
      width: 200
    },
    {
      title: 'Provide additional detail on any supplemental conservation measures implemented in 2023. Verify if these are the same as in the initial application, or if any changes occurred.',
      dataIndex: 'additional_supplement_conservation_measures',
      key: 'additional_supplement_conservation_measures',
      width: 200
    },
    {
      title: 'Describe the method(s) used for effectiveness monitoring, where monitoring was conducted, and if applicable, notes regarding implementation of monitoring activities.',
      dataIndex: 'methods_effective_monitoring',
      key: 'methods_effective_monitoring',
      width: 200
    },
    {
      title: 'Summarize your monitoring results: milkweed stems per plot, percent cover of nectar plants (if applicable), unexpected results, lessons learned, and recommendations for future implementation or monitoring.',
      dataIndex: 'monitoring_results_summary',
      key: 'monitoring_results_summary',
      width: 200
    },
    {
      title: 'Was adaptive management triggered?',
      dataIndex: 'adaptive_management_triggered',
      key: 'adaptive_management_triggered',
      width: 200
    },
    {
      title: 'Describe any adaptive management actions you anticipate implementing, if applicable.',
      dataIndex: 'adaptive_management_actions',
      key: 'adaptive_management_actions',
      width: 200
    },
    {
      title: 'Describe any supplemental effectiveness monitoring implemented and any lessons learned or results that will inform future implementation.',
      dataIndex: 'supplemental_effectiveness_monitoring',
      key: 'supplemental_effectiveness_monitoring',
      width: 200
    },
    {
      title: 'Provide any other general comments about your CCAA implementation or this annual report.',
      dataIndex: 'general_comments',
      key: 'general_comments',
      width: 200
    }
  ]



  const handleFetchOrgs = async () => {
    if(orgs.length === 0){
      try{
        const response = await axios.get('https://rightofway.erc.uic.edu/wp-json/ccaa_route/v1/orgs');
        //console.log('orgs', response.data);
        if(response.data.length > 0){
          setOrgs(response.data);
        }
      }
      catch(error){
        console.log(error);
      }
    }
  }

  const handleFetchAllOrgs = async () => {
    //console.log('fetch all orgs')
  }

  const handleFetchData = async (org) => {
    //console.log('fetch data for org', org)
    //push org to activeOrg
    setActiveOrg(activeOrg => [...activeOrg, org]);
    setLoading(true);
    try{
      const response = await axios.post('https://rightofway.erc.uic.edu/wp-json/monarch_ccaa_route/v1/monarch_ccaa_details',{
        "organization_name": org,
    }
    );
    //console.log('response', response.data);
    //the data in response.data is an object of objects , consolidate all objects of each key into one object
    //setTableData(response.data);
    handleConstructData(response.data);
    setLoading(false);
    }
    catch(error){
      console.log(error);
    }
  }

  const handleConstructData = (data) => {
    let table_data = {};

    table_data['organization_name'] = data['monarch_ccaa_home'][0]['organization_name'];
    table_data['certificate_of_inclusion_number'] = data['monarch_ccaa_home'][0]['inclusion_number'];
    table_data['primary_point_of_contact_name'] = data['monarch_ccaa_home'][0]['contact_name'];
    table_data['address'] = data['monarch_ccaa_home'][0]['address'];
    table_data['phone_number'] = data['monarch_ccaa_home'][0]['phone_number'];
    table_data['email'] = data['monarch_ccaa_home'][0]['email'];
    table_data['acres_enrolled'] = data['monarch_ccaa_annual_reporting'][0]['acres_enrolled'];
    table_data['adopted_acres_target'] = data['monarch_ccaa_annual_reporting'][0]['acres_target'];
    table_data['additional_explanation'] = data['monarch_ccaa_annual_reporting'][0]['additional_explanation'];
    table_data['anticipate_updates'] = data['monarch_ccaa_upcoming_year_forecast'][0]['anticipate_updates'];
    table_data['conservation_measures'] = data['monarch_ccaa_annual_net_conservation'][0]['conservation_measures'];
    table_data['conservation_measures_implementation'] = data['monarch_ccaa_annual_net_conservation'][0]['conservation_measures_implementation'];
    table_data['partners_overlap'] = data['monarch_ccaa_annual_net_conservation'][0]['partners_overlap'];
    table_data['supplemental_measures'] = data['monarch_ccaa_annual_net_conservation'][0]['supplemental_measures'];
    table_data['additional_supplement_conservation_measures'] = data['monarch_ccaa_annual_net_conservation'][0]['additional_supplement_conservation_measures'];
    table_data['methods_effective_monitoring'] = data['monarch_ccaa_summary_effectiveness'][0]['methods_effective_monitoring'];
    table_data['monitoring_results_summary'] = data['monarch_ccaa_summary_effectiveness'][0]['monitoring_results_summary'];
    table_data['adaptive_management_triggered'] = data['monarch_ccaa_summary_effectiveness'][0]['adaptive_management_triggered'];
    table_data['adaptive_management_actions'] = data['monarch_ccaa_summary_effectiveness'][0]['adaptive_management_actions'];
    table_data['supplemental_effectiveness_monitoring'] = data['monarch_ccaa_summary_effectiveness'][0]['supplemental_effectiveness_monitoring'];
    table_data['general_comments'] = data['monarch_ccaa_upcoming_year_forecast'][0]['general_comments'];




    //push table_data to tableData array
    setTableData(tableData => [...tableData, table_data]);
  }


  React.useEffect(() => {
    handleFetchOrgs();
  }
  ,[])

  /*
    Organization Name
    Certificate of Inclusion Number
    Primary Point of Contact Name
    Address
    Phone Number
    Email
    Sector
    Acres Enrolled in 2022 (Report)	Acres Enrolled on CI	"Adopted Acres Target for 2022(Report)

"	Adopted Acres on CI	Does the partner have an implementation schedule? (Y/N) (Exhibit 1)	If so, what is their adopted acres target for 2022? (Exhibit 1)	"Adopted Acres Contributed in 2022 (Report)
"	Are Enrolled Lands and Adopted Acres Target the Same as in CI? If not, explain.	Is Actual Adopted Acres in 2022 (Column N) equal to or greater than Total Adopted Acres Target or 2022 Implementation Schedule Target (if applicable)? (Y/N)	If necessary, provide additional explanation or comments related to the enrolled acres and adopted acres values given above.	Do you anticipate any updates or changes to your Certificate of Inclusion in the coming year?	Describe the updates you anticipate making and when you would like to discuss those updates with UIC.	Have you made any updates to your Section 7 species list or Avoidance & Minimization Measures (AMMs)?	Were Enrolled Acres added and removed to the CI during the last year? (Y/N) (Sent in a CI Mod form)	"What conservation measures did you undertake on your adopted acres in 2022?
"	"Please upload a tracking sheet, shapefile, and/or other supporting documentation of implemented conservation measures.
"	Conservation measures included in the CI	Covered activities in application 	Describe the implementation of conservation measures and adopted acres managed. Verify if these are the same as in the initial application, or if any changes occurred. Summarize any unforeseen or changed circumstances that impacted annual contribution.	General comments on conservation measures and discrepancies	Describe whether your adopted acres contained overlap with another CCAA Partner's adopted acres. If so, name which Partners have overlap and estimate the number of acres or percentage of overlap	Overlap comments and summary 	What supplemental measures did you undertake as part of your CCAA implementation in 2022? (check all that apply)	What are the supplemental measures in CI? (exhibit 1)	"Provide additional detail on any supplemental conservation measures implemented in 2022. Verify if these are the same as in the initial application, or if any changes occurred.
"	Upload any supporting documentation for the previous question here. - Name	Do the supplemental measures and documentation qualify for admin fee discounts?	Upload your updated Section 7 documentation here. - Name	Describe the method(s) used for effectiveness monitoring, where monitoring was conducted, and if applicable, notes regarding implementation of monitoring activities.	Provide a map displaying the general location of where monitoring was conducted as an attachment. - Name	Summarize your monitoring results: milkweed stems per plot, percent cover of nectar plants (if applicable), unexpected results, lessons learned, and recommendations for future implementation or monitoring.	Upload a summary tracking sheet for effectiveness monitoring, other supporting tables, photos, and/or figures as attachments. - Name	Did they meet the monitoring requirements? (number of plots, provide a map, etc)	"Was adaptive management triggered?

"	Did partner report adaptive management trigger correctly and any other comments.	Describe any adaptive management actions you anticipate implementing, if applicable.	Describe any supplemental effectiveness monitoring implemented and any lessons learned or results that will inform future implementation.	Provide any other general comments about your CCAA implementation or this annual report.	Implementation flags checked 	Other notes and observations 	Follow up questions to the partner	Status of review	Highlights or recognition
  */

  return (
    <>
    <div className='container-fluid mt-4'>
    {
          loading ? <div className='mt-4 d-flex flex-row'>
              <div>
                <Text fontSize={'md'} color={'gray.600'}
                fontWeight={600}
                style={
                  {
                    color: 'black'
                  }
                }
                >Fetching from Database
                </Text>
                <Spinner />
              </div>
            </div> : null
        }
      <div className='row'>
          <div className='col-4'>
            <div className='row'>
              <div className='col-6'>
                <Text
                  fontSize={'md'}
                  color={'gray.600'}
                  fontWeight={600}
                  mb={2}>
                  Select Organization
                </Text>
              </div>
              <div className='col-6'>
              <div className='row'>
                    <div>
                    <Select
                    id="login_org"
                    style={{width: '100%', height: '40px'}}
                    onChange={(e) => handleFetchData(e.target.value)}
                  >
                    <option value=''></option>
                    {orgs.map((org,index) => {
                      return <option key={index} value={org.user_name}
                      >{org.user_name}</option>
                    }
                    )}
                  </Select>
                  </div>
                    <div>
                      {
                        orgs.length === 0 ? <div className='row'>
                          <div className='col-8'>
                            <Text fontSize={'md'} color={'gray.600'}>Fetching Organizations
                            </Text>
                          </div>
                          <div className='col-4'>
                            <Spinner />
                          </div>
                          </div> : null
                      }
                    </div>
                  </div>
              </div>
            </div>
          </div>
          <div className='col-8'>
            <Button
              onClick={() => {
                handleFetchAllOrgs();
              }}
              colorScheme={'blue'}
              variant={'solid'}>
              Fetch All Organizations
            </Button>

          </div>
        </div>
        <div className='mt-4 row'>
              <Table
                columns={columns}
                loading={loading}
                dataSource={tableData.map((row) => ({
                  ...row,
                  key: row.organization_name,
                }))
                }
                defaultPageSize={20}
                pageSizeOptions={[10, 20, 30]}
                scroll={{
                  x: 2000,
                  y: 500
                }}
                rowKey="organization_name"
              />
        </div>
    </div>
    </>
  )
}

export default Organizations